export interface Tab {
  tabId: string;
  tabName: string;
  sort: number;
}

export interface Banner {
  img: string;
  href: string;
  sort: number;
  startTime?: Date;
  endTime?: Date;
}

export interface Organ {
  /** 组织id */
  oid: string;
  /** 组织名 */
  oname: string;
  /** 组织icon */
  oicon: string;
  /** 收据页说明 */
  checkLabel: string;
  /** 收据页协议 */
  checkVal: string;
}

export enum DonateBtnType {
  /** 金额优先 */
  Money = 0,
  /** 文案优先 */
  Text = 1,
}

export interface Project {
  /** 组织id */
  oid: string;
  /** 项目名 */
  pid: string;
  /** 所属tab数组，支持同时归属于多个tab */
  tabIds: string[];
  /** 项目名 */
  title: string;
  /** 项目简述 */
  desc: string;
  /** 项目描述 */
  detailDesc: string;
  /** 首页缩略图 */
  img: string;
  /** 详情页项目图片 */
  detailImg: string;
  /** 项目描述中的图片 */
  detailDescImg: string;
  /** 联系方式 */
  contact: string;
  /** 捐款按钮类型 */
  donateBtnType: DonateBtnType;
  /** 受惠人群 */
  donatePeople: string;
  /** 建议捐款金额 */
  amountOptions: AmountOption[];
  /** 最低捐款金额 */
  lowAmount?: number;
  /** 开始时间 */
  startTime?: Date;
  /** 结束时间 */
  endTime?: Date;
  /** 是否在主页展示 */
  isDisplayOnIndex: boolean;
  /** 排序 */
  sort: number;
  /** 是否上线 */
  isOnline: boolean;
  /** 是否参与99公益日 */
  isNineProj: boolean;
}

export interface AmountOption {
  /** 金额 */
  amount: number;
  /** 描述 */
  desc: string;
}

export interface ProjectData extends Project {
  /** 捐款总数 */
  totalCount: number;
}

export interface PageData {
  tabCfg: Tab[],
  bannerCfg: Banner[],
  organCfg: Organ[],
  projectData: ProjectData[],
  allProjectData: ProjectData[],
}
